import { Button, Flex } from '@bridebook/aura';
import { PlusCircle } from '@bridebook/aura/src/icons';
import { IWedding_RSVP } from '@bridebook/models/source/models/Weddings.types';
import { Tooltip } from '@bridebook/ui';
import { IconInfoQuestionMark } from '@bridebook/ui/src/icons/dynamic';
import { RsvpDeadline } from '@bridebook/web/components/wedding-website/rsvp/rsvp-list/partials/rsvp-deadline';
import { RsvpText } from '@bridebook/web/components/wedding-website/rsvp/rsvp-list/partials/rsvp-text';
import { RsvpTitle } from '@bridebook/web/components/wedding-website/rsvp/rsvp-list/partials/rsvp-title';
import { ListItem } from '@bridebook/web/components/wedding-website/wedding-details/partials/list-item/list-item-tw';
import { EmptyGuestlistBanner } from '@bridebook/web/components/wedding-website/wedding-details/sections/rsvp/empty-guestlist-banner';
import { isMainEvent } from '@bridebook/web/lib/events/types';
import { useUnifiedEvents } from '@bridebook/web/lib/events/use-unified-events';
import { useWeddingRsvp } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-wedding-rsvp';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import { useRsvpModal } from '@bridebook/web/components/wedding-website/rsvp/rsvp-modal.context';
import { useCreateWeddingRsvpIfMissing } from '@bridebook/web/lib/weddings/hooks/use-create-wedding-rsvp-if-missing';
export const RsvpList = () => {
  const { t } = useTranslation('weddingWebsite');
  const { data: weddingRsvp, isLoading: isWeddingRsvpQueryLoading } = useWeddingRsvp();
  const { unifiedEvents, isLoading: isUnifiedEventsLoading } = useUnifiedEvents();
  useCreateWeddingRsvpIfMissing();

  const { setRsvpQuestionId, closeModal } = useRsvpModal();

  const eventNamesById = useMemo(
    () =>
      isWeddingRsvpQueryLoading || isUnifiedEventsLoading
        ? {}
        : unifiedEvents.reduce<Record<string, string>>((acc, cur) => {
            acc[cur.id] = cur.name + (isMainEvent(cur) ? '*' : '');
            return acc;
          }, {}),
    [isUnifiedEventsLoading, isWeddingRsvpQueryLoading, unifiedEvents],
  );

  const questions = weddingRsvp?.questions;

  const getQuestionLabel = (question: IWedding_RSVP['questions'][number]) => {
    if (!isUnifiedEventsLoading && unifiedEvents.length === question.events.length)
      return t('rsvp.event.question.all');
    return question.events.map((id) => eventNamesById[id]).join(', ');
  };

  return (
    <Flex className="flex-col gap-4 xl:px-[100px]">
      <EmptyGuestlistBanner onLinkClick={closeModal} />
      <Flex className="flex-col gap-2">
        <Flex className="flex-col gap-2">
          <Flex className="flex-col gap-1">
            <RsvpTitle>{t('rsvp.main.heading.title')}</RsvpTitle>
            <RsvpText>{t('rsvp.main.heading.text')}</RsvpText>
          </Flex>

          <Flex className="flex-col">
            {/* default item */}
            <ListItem
              label={t('rsvp.main.question.attendance.label') + '*'}
              body={t('rsvp.main.question.attendance.text')}
              classNames={{
                label: 'text-space-40',
                body: 'text-space-60',
              }}
              rightElement={
                <Tooltip
                  text={t('rsvp.main.question.attendance.hint')}
                  orientation="left"
                  renderTrigger={() => <IconInfoQuestionMark width={16} color="space" />}
                />
              }
            />

            {questions?.map((question) => (
              <button
                key={question.id}
                onClick={() => setRsvpQuestionId(question.id)}
                className="text-left">
                <ListItem label={getQuestionLabel(question)} body={question.question} />
              </button>
            ))}
          </Flex>

          <Button
            variant="ghost"
            icon={PlusCircle}
            onClick={() => setRsvpQuestionId('add')}
            className="self-start">
            {t('rsvp.main.question.button.add')}
          </Button>
        </Flex>

        <RsvpDeadline />
      </Flex>
    </Flex>
  );
};
